import React from 'react'

const Insight = () => {
    return (
        <div className='bg-[#06000A] gap-5 pt-[10%] pb-[5%] lg:px-[8%] px-[4%] flex flex-col'>
            <div data-aos="zoom-out" className='flex w-full items-center justify-center'>
                <div className='flex w-full items-center justify-center'>
                    <div className='lg:w-[60%] gap-4 w-full flex flex-col items-center justify-center'>
                        <p className='lg:text-[55px] text-[22px] text-white font-semibold '>Current Mining <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                            Metrics
                        </span></p>
                        <p className='text-[15px] text-[#ffffff] text-center'>Access up-to-date performance data from our global mining operations.</p>
                    </div>
                </div>
            </div>
            <div className='flex lg:flex-row flex-col gap-3 items-center lg:gap-10'>
                <div data-aos="fade-right" className='lg:w-1/2 w-full'>
                    <img src="/Blockfarm/hosting/insight.svg" alt="" />
                </div>
                <div data-aos="fade-left" className='flex flex-col gap-6'>
                    <div className='flex flex-row lg:gap-5 items-center'>
                        <div>
                            <img src="/Blockfarm/hosting/efficient.svg" alt="" />
                        </div>
                        <div  className='flex flex-col gap-1'>
                            <p className='lg:text-[23px] text-[15px] text-white font-semibold'>Efficient Miner Hosting</p>
                            <p className='lg:text-[16px] text-[12px] text-white text-opacity-75'>Hosting 3,600 miners with optimal performance and energy management.</p>
                        </div>
                    </div>
                    <div className='flex flex-row lg:gap-5 items-center'>
                        <div>
                            <img src="/Blockfarm/hosting/energy.svg" alt="" />
                        </div>
                        <div  className='flex flex-col gap-1'>
                            <p className='lg:text-[23px] text-[15px] text-white font-semibold'>Energy-Smart Operations</p>
                            <p className='lg:text-[16px] text-[12px] text-white text-opacity-75'>Maintaining 12 MW power consumption focused on sustainability and efficiency.</p>
                        </div>
                    </div>
                    <div className='flex flex-row lg:gap-5 items-center'>
                        <div>
                            <img src="/Blockfarm/hosting/high-perfomance.svg" alt="" />
                        </div>
                        <div className='flex flex-col gap-1'>
                            <p className='lg:text-[23px] text-[15px] text-blue-600 font-semibold'>High-Performance Hashrate</p>
                            <p className='lg:text-[16px] text-[12px] text-white text-opacity-75'>Achieving a strong online hashrate of 403 PH/s for enhanced mining productivity.</p>
                        </div>
                    </div>
                    <div className='flex flex-row lg:gap-5 items-center'>
                        <div>
                            <img src="/Blockfarm/hosting/extensive.svg" alt="" />
                        </div>
                        <div  className='flex flex-col gap-1'>
                            <p className='lg:text-[23px] text-[15px]  text-white font-semibold'>Extensive Hosting Capacity</p>
                            <p className='lg:text-[16px] text-[12px] text-white text-opacity-75'>Operating across three advanced facilities, supporting large-scale mining infrastructure.</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Insight